import React from "react";
import { useSelector } from "react-redux";

import { price } from "../redux/createReducer";

import CartItem from "./CartItem";

export default function Cart() {
  const count = useSelector((state) => state);
  let cartProduct = count?.CartReducer?.product?.filter(
    (data) => data.cartQuantity !== 0
  );
  return (
    <div class="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
      <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        {cartProduct.map((item) => (
          <CartItem item={item} />
        ))}
        <div class="flex justify-center items-center text-center">
          <div class="text-xl font-semibold">
            <p>Total Item</p>
            <p class="text-5xl">{count?.ValueReducer?.value}</p>
          </div>
        </div>
      </div>

      <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div class="flex justify-center items-center text-center">
          <div class="text-xl font-semibold">
            <p>Total Price</p>
            <p class="text-5xl">{price}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
